import { render, staticRenderFns } from "./MiniModeCourse.vue?vue&type=template&id=4311b983&"
import script from "@/scripts/MiniMode/MiniModeCourse/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MiniMode/MiniModeCourse/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports